<fieldset class="ais-RefinementList">
  <div>
    <!-- this div is here to simulate the ng-ais-header container -->
    <button
      class="ais-RefinementList-header ais-header filtersShortCheckbox"
      [ngClass]="{'ais-RefinementList-header--closed': !showRefinementBody}"
      (click)="toggleShowBody()"
      [attr.aria-expanded]="showRefinementBody"
    >
      <legend *ngIf="options.label === 'CATALOG.FILTERS.SIZE.1'" i18n="@@CATALOG.FILTERS.SIZE.1">Women’s Size</legend>
      <legend *ngIf="options.label === 'CATALOG.FILTERS.SIZE.2'" i18n="@@CATALOG.FILTERS.SIZE.2">Jean size</legend>
      <legend *ngIf="options.label === 'CATALOG.FILTERS.SIZE.3'" i18n="@@CATALOG.FILTERS.SIZE.3">
        Women’s shoe size
      </legend>
      <legend *ngIf="options.label === 'CATALOG.FILTERS.SIZE.4'" i18n="@@CATALOG.FILTERS.SIZE.4">
        Men’s shoe size
      </legend>
      <legend *ngIf="options.label === 'CATALOG.FILTERS.SIZE.5'" i18n="@@CATALOG.FILTERS.SIZE.5">Jean size</legend>
      <legend *ngIf="options.label === 'CATALOG.FILTERS.SIZE.6'" i18n="@@CATALOG.FILTERS.SIZE.6">
        Child’s shoe size
      </legend>
      <legend *ngIf="options.label === 'CATALOG.FILTERS.SIZE.7'" i18n="@@CATALOG.FILTERS.SIZE.7">
        Accessories size
      </legend>
      <legend *ngIf="options.label === 'CATALOG.FILTERS.SIZE.8'" i18n="@@CATALOG.FILTERS.SIZE.8">Bra-top size</legend>
      <legend *ngIf="options.label === 'CATALOG.FILTERS.SIZE.9'" i18n="@@CATALOG.FILTERS.SIZE.9">
        Accessories size
      </legend>
      <legend *ngIf="options.label === 'CATALOG.FILTERS.SIZE.10'" i18n="@@CATALOG.FILTERS.SIZE.10">Men’s size</legend>
      <legend *ngIf="options.label === 'CATALOG.FILTERS.SIZE.11'" i18n="@@CATALOG.FILTERS.SIZE.11">Child’s size</legend>
      <legend *ngIf="options.label === 'CATALOG.FILTERS.SIZE.12'" i18n="@@CATALOG.FILTERS.SIZE.12">
        Waist measurement
      </legend>
      <legend *ngIf="options.label === 'CATALOG.FILTERS.SIZE.13'" i18n="@@CATALOG.FILTERS.SIZE.13">Glove size</legend>
      <legend *ngIf="options.label === 'CATALOG.FILTERS.SIZE.14'" i18n="@@CATALOG.FILTERS.SIZE.14">Hat size</legend>
      <legend *ngIf="options.label === 'CATALOG.FILTERS.SIZE.15'" i18n="@@CATALOG.FILTERS.SIZE.15">Ring size</legend>
      <legend *ngIf="options.label === 'CATALOG.FILTERS.SIZE.16'" i18n="@@CATALOG.FILTERS.SIZE.16">
        Waist measurement
      </legend>
      <legend *ngIf="options.label === 'CATALOG.FILTERS.SIZE.17'" i18n="@@CATALOG.FILTERS.SIZE.17">Glove size</legend>
      <legend *ngIf="options.label === 'CATALOG.FILTERS.SIZE.18'" i18n="@@CATALOG.FILTERS.SIZE.18">Hat size</legend>
      <legend *ngIf="options.label === 'CATALOG.FILTERS.SIZE.19'" i18n="@@CATALOG.FILTERS.SIZE.19">Suit size</legend>
      <legend *ngIf="options.label === 'CATALOG.FILTERS.SIZE.20'" i18n="@@CATALOG.FILTERS.SIZE.20">Shirt size</legend>
      <legend *ngIf="options.label === 'CATALOG.FILTERS.SIZE.21'" i18n="@@CATALOG.FILTERS.SIZE.21">Pants size</legend>
      <legend *ngIf="options.label === 'CATALOG.FILTERS.SIZE.22'" i18n="@@CATALOG.FILTERS.SIZE.22">
        Swimwear size
      </legend>
      <legend *ngIf="options.label === 'CATALOG.FILTERS.SIZE.23'" i18n="@@CATALOG.FILTERS.SIZE.23">Polo size</legend>
      <legend *ngIf="options.label === 'CATALOG.FILTERS.SIZE.24'" i18n="@@CATALOG.FILTERS.SIZE.24">T-shirt size</legend>
      <legend *ngIf="options.label === 'CATALOG.FILTERS.SIZE.25'" i18n="@@CATALOG.FILTERS.SIZE.25">Top size</legend>
    </button>
  </div>
  <div class="ais-RefinementList-body ais-body" [ngStyle]="{display: showRefinementBody ? 'block' : 'none'}">
    <div class="filtersShortCheckbox__subtitle">
      <span class="filtersShortCheckbox__subtitle__sizeLabel vc-text-s">
        <span i18n="@@CATALOG.FILTERS.SIZE_STANDARD">Size standard:</span> {{ sizeLabel }}</span
      >
      <button class="filtersShortCheckbox__subtitle__sizeGuideLink vc-link" (click)="openSizeGuide()">
        <span i18n="@@PRODUCT.DETAILS.SIZES_GUIDE" class="visuallyhidden">size guide</span>
        <vc-sprite-icons name="info" class=""></vc-sprite-icons>
      </button>
    </div>
    <ul class="ais-RefinementList-list filtersShortCheckbox__list">
      <li *ngFor="let item of items | appSortByNumber" class="filtersShortCheckbox__item">
        <input
          id="{{ item.value }}"
          class="filtersShortCheckbox__item__input visuallyhidden"
          type="checkbox"
          (change)="refine($event, item)"
          [attr.checked]="item.isRefined ? 'checked' : null"
        />
        <label for="{{ item.value }}" class="filtersShortCheckbox__item__label">{{ item.label }}</label>
        <div class="filtersShortCheckbox__item__tooltip">
          {{ item.label }} <span class="filtersShortCheckbox__item__tooltip__count">({{ item.count }})</span>
        </div>
      </li>
    </ul>
  </div>
</fieldset>
